<div class="px-2 sm:px-4 md:px-8 py-4 sm:py-6 max-w-7xl mx-auto">

  <!-- Header -->
  <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4" style="margin-bottom: 20px;">
    <div class="flex items-center gap-3">
      <mat-icon style="color: #1C593D; font-size: 28px; width: 28px; height: 28px; flex-shrink: 0;">receipt_long</mat-icon>
      <div>
        <h1 class="trx-title" style="font-size: 1.4rem; font-weight: 700; color: #1f2937; margin: 0;">
          {{ view === 'historial' ? 'Historial de Transacciones' : 'Transacciones alto valor' }}
        </h1>
        <p style="font-size: 0.8rem; color: #6b7280; margin: 2px 0 0;">Consulta tus operaciones</p>
      </div>
    </div>

    <!-- Toggle buttons -->
    <div *ngIf="viewInfo" class="flex gap-2">
      <button type="button" (click)="onHistorialClick()"
        [disabled]="view === 'historial'"
        [style.background]="view === 'historial' ? '#1C593D' : 'white'"
        [style.color]="view === 'historial' ? 'white' : '#374151'"
        [style.border]="view === 'historial' ? '1px solid #1C593D' : '1px solid #d1d5db'"
        [style.opacity]="view === 'historial' ? '1' : '0.9'"
        style="padding: 8px 18px; border-radius: 10px; font-weight: 600; font-size: 0.82rem; cursor: pointer; transition: all 0.2s ease;">
        Historial
      </button>
      <button type="button" (click)="onListaManualesClick()"
        [disabled]="view === 'lista manuales'"
        [style.background]="view === 'lista manuales' ? '#1C593D' : 'white'"
        [style.color]="view === 'lista manuales' ? 'white' : '#374151'"
        [style.border]="view === 'lista manuales' ? '1px solid #1C593D' : '1px solid #d1d5db'"
        [style.opacity]="view === 'lista manuales' ? '1' : '0.9'"
        style="padding: 8px 18px; border-radius: 10px; font-weight: 600; font-size: 0.82rem; cursor: pointer; transition: all 0.2s ease;">
        Alto valor
      </button>
    </div>
  </div>


  <!-- Chileno con saldo VES: elige entre su historial CLP y sus movimientos VES -->
  <div *ngIf="view === 'historial' && esChilenoConVes" class="flex gap-2" style="margin-bottom: 16px;">
    <button type="button" *ngFor="let moneda of ['CLP', 'VES']" (click)="monedaHistorial = $any(moneda)"
      [attr.aria-pressed]="monedaHistorial === moneda"
      [style.background]="monedaHistorial === moneda ? '#1C593D' : 'white'"
      [style.color]="monedaHistorial === moneda ? 'white' : '#374151'"
      [style.border]="monedaHistorial === moneda ? '1px solid #1C593D' : '1px solid #d1d5db'"
      style="padding: 6px 16px; border-radius: 10px; font-weight: 600; font-size: 0.82rem; cursor: pointer;">
      {{ moneda }}
    </button>
  </div>

  <!-- ═══ VISTA HISTORIAL CLP (no VE) ═══ -->
  <div *ngIf="view === 'historial' && tipoId !== 'VE' && monedaHistorial === 'CLP'" class="flex flex-col gap-3">

    <!-- Paginator -->
    <div class="flex justify-center">
      <mat-paginator
        (page)="onPageChange($event)"
        [length]="totalItems"
        [pageSize]="pageSize"
        [showFirstLastButtons]="true"
        [pageSizeOptions]="[5, 10, 25, 50]"
        [pageIndex]="currentPage - 1"
        aria-label="Select page">
      </mat-paginator>
    </div>

    <app-transaction-card *ngFor="let transaccion of listaTransacciones; let i = index"
      [transaccion]="transaccion"
      [expanded]="expandedCardIndex === i"
      (toggleExpand)="toggleHistorialCard(i)">
    </app-transaction-card>

    <!-- Empty state -->
    <div *ngIf="listaTransacciones.length === 0"
      style="text-align: center; padding: 48px 20px;">
      <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db; margin-bottom: 12px;">receipt_long</mat-icon>
      <p style="font-size: 0.95rem; color: #6b7280; margin: 0;">No hay transacciones para mostrar</p>
    </div>
  </div>

  <!-- ═══ VISTA HISTORIAL VES / USDT (VE; el chileno ve solo la pestaña VES) ═══ -->
  <div *ngIf="view === 'historial' && (tipoId === 'VE' || (esChilenoConVes && monedaHistorial === 'VES'))">
    <mat-tab-group class="historial-tabs">
      <!-- Tab VES -->
      <mat-tab label="VES">
        <div class="flex flex-col gap-3" style="margin-top: 12px;">
          <!-- Paginador VES -->
          <mat-paginator
            *ngIf="totalMovimientosVes > 0"
            [length]="totalMovimientosVes"
            [pageSize]="pageSizeVes"
            [pageSizeOptions]="[10, 20, 50]"
            [pageIndex]="currentPageVes - 1"
            (page)="onPageChangeVes($event)"
            showFirstLastButtons
            aria-label="Seleccionar pagina de movimientos VES"
            style="margin-bottom: 12px;">
          </mat-paginator>

          <!-- Loading -->
          <div *ngIf="loadingVes" style="text-align: center; padding: 48px 20px;">
            <mat-spinner diameter="36" style="margin: 0 auto 12px;"></mat-spinner>
            <p style="font-size: 0.85rem; color: #6b7280; margin: 0;">Cargando movimientos...</p>
          </div>

          <!-- Cards de movimientos VES -->
          <ng-container *ngIf="!loadingVes">
            <div *ngFor="let mov of movimientosVes; let i = index"
              style="background: white; border-radius: 14px; border: 1px solid #e5e7eb; overflow: hidden; box-shadow: 0 1px 6px rgba(0,0,0,0.05);">

              <!-- Header row -->
              <div (click)="expandedVesIndex = expandedVesIndex === i ? null : i"
                style="padding: 12px 14px; display: flex; align-items: flex-start; gap: 10px; cursor: pointer;"
                [style.background]="expandedVesIndex === i ? 'linear-gradient(135deg, #f0fdf4, #ecfdf5)' : 'white'">

                <!-- Icon credito/debito (hidden on narrow) -->
                <div class="hidden sm:flex" style="width: 36px; height: 36px; border-radius: 10px; align-items: center; justify-content: center; flex-shrink: 0;"
                  [style.background]="mov.creditVes > 0 ? '#f0fdf4' : '#fef2f2'">
                  <mat-icon style="font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;"
                    [style.color]="mov.creditVes > 0 ? '#16a34a' : '#dc2626'">
                    {{ mov.creditVes > 0 ? 'south_west' : 'north_east' }}
                  </mat-icon>
                </div>

                <!-- Info central -->
                <div style="flex: 1; min-width: 0;">
                  <div style="font-weight: 700; font-size: 0.85rem; color: #111827; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                    {{ sanitizeVesDescription(mov) }}
                  </div>
                  <div style="font-size: 0.72rem; color: #9ca3af; margin-top: 2px;">
                    {{ mov.createdAt | date:'medium' }}
                  </div>
                  <!-- Monto + status badge -->
                  <div class="flex items-center gap-2 flex-wrap" style="margin-top: 4px;">
                    <span style="font-weight: 700; font-size: 0.85rem;"
                      [style.color]="vesSinEfectoEnSaldo(mov) ? '#9ca3af' : (mov.creditVes > 0 ? '#16a34a' : '#dc2626')"
                      [style.text-decoration]="mov.status === 'REJECTED' ? 'line-through' : 'none'">
                      {{ mov.creditVes > 0 ? '+' : '-' }}Bs. {{ (mov.creditVes > 0 ? mov.creditVes : mov.debitVes) | number:'1.2-2' }}
                    </span>
                    <span
                      style="color: white; display: inline-block; padding: 2px 8px; border-radius: 6px; font-size: 0.65rem; font-weight: 700;"
                      [style.background]="getVesStatusColor(mov.status)">
                      {{ getVesStatusLabel(mov.status) }}
                    </span>
                  </div>
                </div>

                <!-- Flecha -->
                <mat-icon
                  style="font-size: 20px; width: 20px; height: 20px; color: #9ca3af; flex-shrink: 0; transition: transform 0.2s ease; margin-top: 4px;"
                  [style.transform]="expandedVesIndex === i ? 'rotate(180deg)' : 'rotate(0)'">
                  expand_more
                </mat-icon>
              </div>

              <!-- Detalles expandibles -->
              <div *ngIf="expandedVesIndex === i" style="border-top: 1px solid #f3f4f6;">
                <div style="padding: 10px 14px 12px;" class="sm:pl-16">
                  <div class="flex flex-wrap gap-3" style="margin-bottom: 2px;">
                    <div *ngIf="mov.creditVes > 0" style="display: flex; align-items: center; gap: 6px;">
                      <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Credito:</span>
                      <span style="font-size: 0.85rem; font-weight: 700; color: #16a34a;">Bs. {{ mov.creditVes | number:'1.2-2' }}</span>
                    </div>
                    <div *ngIf="mov.debitVes > 0" style="display: flex; align-items: center; gap: 6px;">
                      <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Debito:</span>
                      <span style="font-size: 0.85rem; font-weight: 700; color: #dc2626;">Bs. {{ mov.debitVes | number:'1.2-2' }}</span>
                    </div>
                    <div style="display: flex; align-items: center; gap: 6px;">
                      <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Saldo:</span>
                      <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f;">Bs. {{ mov.balanceVes | number:'1.2-2' }}</span>
                    </div>
                  </div>
                  <p *ngIf="notaVesMovimiento(mov)" style="font-size: 0.75rem; color: #92400e; margin: 4px 0 0;">{{ notaVesMovimiento(mov) }}</p>
                  <div *ngIf="mov.referenceId" class="flex flex-wrap gap-x-4 gap-y-1" style="margin-top: 4px;">
                    <div style="display: flex; align-items: center; gap: 4px;">
                      <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Ref:</span>
                      <span style="font-size: 0.78rem; font-weight: 600; color: #374151; font-family: monospace; word-break: break-all;">{{ mov.referenceId }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>

          <!-- Empty state VES -->
          <div *ngIf="!loadingVes && movimientosVes.length === 0"
            style="text-align: center; padding: 48px 20px;">
            <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db; margin-bottom: 12px;">receipt_long</mat-icon>
            <p style="font-size: 0.95rem; color: #6b7280; margin: 0;">No hay movimientos VES para mostrar</p>
          </div>
        </div>
      </mat-tab>

      <!-- Tab USDT (solo VE: el USDT del chileno sigue en su historial de siempre) -->
      <mat-tab label="USDT" *ngIf="tipoId === 'VE'">
        <div style="margin-top: 12px;">
          <!-- Loading -->
          <div *ngIf="loadingUsdt" style="text-align: center; padding: 48px 20px;">
            <mat-spinner diameter="36" style="margin: 0 auto 12px;"></mat-spinner>
            <p style="font-size: 0.85rem; color: #6b7280; margin: 0;">Cargando movimientos USDT...</p>
          </div>

          <ng-container *ngIf="!loadingUsdt">

            <!-- ══ Swaps pendientes de aprobación ══ -->
            <ng-container *ngIf="usdtPendingSwaps.length > 0">
              <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
                <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #f59e0b;">schedule</mat-icon>
                <span style="font-weight: 700; font-size: 0.85rem; color: #92400e;">Pendientes de aprobaci&oacute;n</span>
                <span style="background: #f59e0b; color: white; font-size: 0.65rem; font-weight: 700; padding: 1px 7px; border-radius: 10px;">
                  {{ usdtPendingSwaps.length }}
                </span>
              </div>
              <div class="flex flex-col gap-3" style="margin-bottom: 16px;">
                <div *ngFor="let swap of usdtPendingSwaps"
                  style="background: white; border-radius: 14px; border: 1px solid #fde68a; overflow: hidden; box-shadow: 0 1px 6px rgba(0,0,0,0.05);">
                  <div style="padding: 12px 14px; display: flex; align-items: flex-start; gap: 10px; background: linear-gradient(135deg, #fffbeb, #fef3c7);">
                    <div class="hidden sm:flex" style="width: 36px; height: 36px; border-radius: 10px; background: #fef3c7; align-items: center; justify-content: center; flex-shrink: 0;">
                      <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #f59e0b; flex-shrink: 0;">swap_horiz</mat-icon>
                    </div>
                    <div style="flex: 1; min-width: 0;">
                      <div style="font-weight: 700; font-size: 0.85rem; color: #92400e;">{{ sanitizePendingSwapDescription(swap) }}</div>
                      <div style="font-size: 0.72rem; color: #b45309; margin-top: 2px;">{{ swap.createdAt | date:'medium' }}</div>
                      <div style="margin-top: 4px; display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                        <span *ngIf="swap.debitVes > 0" style="font-weight: 700; font-size: 0.85rem; color: #dc2626;">
                          -${{ swap.debitVes | number:'1.2-2' }} USDT
                        </span>
                        <span style="color: white; display: inline-block; padding: 2px 8px; border-radius: 6px; font-size: 0.65rem; font-weight: 700; background: #f59e0b;">
                          Pendiente
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <!-- ══ Historial unificado (retiros + movimientos) ══ -->
            <div *ngIf="unifiedUsdtMovements.length > 0"
              style="display: flex; align-items: center; gap: 8px; margin-bottom: 10px;">
              <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #1e5a3f;">receipt_long</mat-icon>
              <span style="font-weight: 700; font-size: 0.85rem; color: #1e5a3f;">Historial de movimientos</span>
            </div>

            <mat-paginator
              *ngIf="totalMovimientosUsdt > 0"
              [length]="totalMovimientosUsdt"
              [pageSize]="pageSizeUsdt"
              [pageSizeOptions]="[10, 20, 50]"
              [pageIndex]="currentPageUsdt - 1"
              (page)="onPageChangeUsdt($event)"
              showFirstLastButtons
              aria-label="Seleccionar pagina de movimientos USDT"
              style="margin-bottom: 8px;">
            </mat-paginator>

            <div class="flex flex-col gap-3">
              <div *ngFor="let mov of unifiedUsdtMovements; let i = index"
                style="background: white; border-radius: 14px; border: 1px solid #e5e7eb; overflow: hidden; box-shadow: 0 1px 6px rgba(0,0,0,0.05);">

                <!-- Header -->
                <div (click)="expandedUsdtIndex = expandedUsdtIndex === i ? null : i"
                  style="padding: 12px 14px; display: flex; align-items: flex-start; gap: 10px; cursor: pointer;"
                  [style.background]="expandedUsdtIndex === i ? 'linear-gradient(135deg, #f0fdf4, #ecfdf5)' : 'white'">

                  <div class="hidden sm:flex" style="width: 36px; height: 36px; border-radius: 10px; align-items: center; justify-content: center; flex-shrink: 0;"
                    [style.background]="mov.isCredit ? '#f0fdf4' : '#fef2f2'">
                    <mat-icon style="font-size: 20px; width: 20px; height: 20px; flex-shrink: 0;"
                      [style.color]="mov.isCredit ? '#16a34a' : '#dc2626'">
                      {{ mov.isCredit ? 'south_west' : 'north_east' }}
                    </mat-icon>
                  </div>

                  <div style="flex: 1; min-width: 0;">
                    <div style="font-weight: 700; font-size: 0.85rem; color: #111827; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                      {{ mov.label }}
                    </div>
                    <div style="font-size: 0.72rem; color: #9ca3af; margin-top: 2px;">
                      {{ mov.date | date:'medium' }}
                    </div>
                    <div style="margin-top: 4px; display: flex; align-items: center; gap: 8px; flex-wrap: wrap;">
                      <span style="font-weight: 700; font-size: 0.85rem;"
                        [style.color]="mov.isCredit ? '#16a34a' : '#dc2626'">
                        {{ mov.isCredit ? '+' : '-' }}${{ mov.amount | number:'1.2-2' }}
                      </span>
                      <span style="color: white; display: inline-block; padding: 2px 8px; border-radius: 6px; font-size: 0.65rem; font-weight: 700;"
                        [style.background]="getWithdrawalStatusColor(mov.status)">
                        {{ getWithdrawalStatusLabel(mov.status) }}
                      </span>
                    </div>
                  </div>

                  <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #9ca3af; flex-shrink: 0; transition: transform 0.2s ease; margin-top: 4px;"
                    [style.transform]="expandedUsdtIndex === i ? 'rotate(180deg)' : 'rotate(0)'">
                    expand_more
                  </mat-icon>
                </div>

                <!-- Detalle expandible -->
                <div *ngIf="expandedUsdtIndex === i" style="border-top: 1px solid #f3f4f6;">
                  <div style="padding: 10px 14px 12px; overflow: hidden; min-width: 0;" class="sm:pl-16">

                    <!-- Cardex details -->
                    <ng-container *ngIf="mov.source === 'cardex'">
                      <div style="display: flex; flex-wrap: wrap; gap: 12px; margin-bottom: 2px;">
                        <div *ngIf="mov.haber && mov.haber > 0">
                          <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Cr&eacute;dito: </span>
                          <span style="font-size: 0.85rem; font-weight: 700; color: #16a34a;">${{ mov.haber | number:'1.2-2' }}</span>
                        </div>
                        <div *ngIf="mov.debe && mov.debe > 0">
                          <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">D&eacute;bito: </span>
                          <span style="font-size: 0.85rem; font-weight: 700; color: #dc2626;">${{ mov.debe | number:'1.2-2' }}</span>
                        </div>
                        <div *ngIf="mov.saldo !== undefined">
                          <span style="font-size: 0.75rem; font-weight: 600; color: #6b7280;">Saldo: </span>
                          <span style="font-size: 0.85rem; font-weight: 700; color: #1e5a3f;">${{ mov.saldo | number:'1.2-2' }}</span>
                        </div>
                      </div>
                      <div *ngIf="mov.description" style="margin-top: 4px; font-size: 0.72rem; color: #374151; word-break: break-all; overflow-wrap: anywhere;">
                        {{ mov.description }}
                      </div>
                    </ng-container>

                    <!-- Withdrawal details -->
                    <ng-container *ngIf="mov.source === 'withdrawal'">
                      <div *ngIf="mov.walletAddress" style="margin-bottom: 4px; font-size: 0.75rem;">
                        <span style="font-weight: 600; color: #6b7280;">Wallet: </span>
                        <span style="color: #374151; font-family: monospace; word-break: break-all;">{{ mov.walletAddress }}</span>
                      </div>
                      <div style="display: flex; flex-wrap: wrap; gap: 12px; font-size: 0.75rem;">
                        <div *ngIf="mov.fee !== null && mov.fee !== undefined">
                          <span style="font-weight: 600; color: #6b7280;">Fee: </span>
                          <span style="font-weight: 700; color: #374151;">${{ mov.fee | number:'1.2-2' }}</span>
                        </div>
                        <div *ngIf="mov.netAmount !== null && mov.netAmount !== undefined">
                          <span style="font-weight: 600; color: #6b7280;">Neto: </span>
                          <span style="font-weight: 700; color: #1e5a3f;">${{ mov.netAmount | number:'1.2-2' }}</span>
                        </div>
                      </div>
                      <div *ngIf="mov.rejectionReason" style="margin-top: 4px; font-size: 0.72rem; color: #dc2626;">
                        <span style="font-weight: 600;">Motivo: </span>{{ mov.rejectionReason }}
                      </div>
                    </ng-container>

                  </div>
                </div>
              </div>
            </div>

            <!-- Empty state -->
            <div *ngIf="unifiedUsdtMovements.length === 0 && usdtPendingSwaps.length === 0"
              style="text-align: center; padding: 48px 20px;">
              <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db; margin-bottom: 12px;">receipt_long</mat-icon>
              <p style="font-size: 0.95rem; color: #6b7280; margin: 0;">No hay movimientos USDT para mostrar</p>
            </div>

          </ng-container>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <!-- ═══ VISTA LISTA MANUALES ═══ -->
  <div *ngIf="view === 'lista manuales'">

    <!-- Tabla Desktop -->
    <div class="hidden lg:block" style="background: white; border-radius: 16px; border: 1px solid #e5e7eb; overflow: hidden; box-shadow: 0 2px 8px rgba(0,0,0,0.06);">
      <div style="overflow-x: auto;">
        <table mat-table [dataSource]="dataSourceHistorial" matSort (matSortChange)="sortDataHistory($event)" *ngIf="dataSourceHistorial" style="width: 100%;">

          <!-- Monto Promesa -->
          <ng-container matColumnDef="totalEnvio">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Monto Promesa</th>
            <td mat-cell *matCellDef="let row" style="font-weight: 600; color: #1e5a3f;">
              {{ row.totalEnvio | currency:'USD':'symbol-narrow':'1.2-2':'en-US' }}
            </td>
          </ng-container>

          <!-- Moneda Local -->
          <ng-container matColumnDef="monedaLocal">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Moneda</th>
            <td mat-cell *matCellDef="let row" style="color: #374151;">{{ row.monedaLocal }}</td>
          </ng-container>

          <!-- Total Destino -->
          <ng-container matColumnDef="totalDest">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Total Destino</th>
            <td mat-cell *matCellDef="let row" style="font-weight: 600; color: #1e5a3f;">
              {{ row.totalDest | currency:'USD':'symbol-narrow':'1.2-2':'en-US' }}
            </td>
          </ng-container>

          <!-- Moneda Destino -->
          <ng-container matColumnDef="monedaDestino">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Destino</th>
            <td mat-cell *matCellDef="let row" style="color: #374151;">{{ row.monedaDestino }}</td>
          </ng-container>

          <!-- Valor Pagado -->
          <ng-container matColumnDef="valorPagado">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Valor Pagado</th>
            <td mat-cell *matCellDef="let row" style="font-weight: 600; color: #2563eb;">
              {{ row.valorPagado | currency:'USD':'symbol-narrow':'1.2-2':'en-US' }}
            </td>
          </ng-container>

          <!-- Tasa -->
          <ng-container matColumnDef="tasa">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Tasa</th>
            <td mat-cell *matCellDef="let row" style="font-weight: 600; color: #7c3aed;">{{ row.tasa }}</td>
          </ng-container>

          <!-- Wallet -->
          <ng-container matColumnDef="walletTrx">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Wallet</th>
            <td mat-cell *matCellDef="let row" style="font-family: monospace; font-size: 0.78rem; color: #374151; max-width: 180px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
              {{ row.walletTrx }}
            </td>
          </ng-container>

          <!-- Estado -->
          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef mat-sort-header style="text-align: center;">Estado</th>
            <td mat-cell *matCellDef="let row" style="text-align: center;">
              <span style="display: inline-block; padding: 3px 12px; border-radius: 6px; font-size: 0.72rem; font-weight: 700;"
                [style.background]="getEstadoManualBg(row.estado)"
                [style.color]="'white'">
                {{ row.estado }}
              </span>
            </td>
          </ng-container>

          <!-- Fecha Creación -->
          <ng-container matColumnDef="fechaCreacion">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Creación</th>
            <td mat-cell *matCellDef="let row" style="font-size: 0.78rem; color: #6b7280; white-space: nowrap;">
              {{ row.fechaCreacion | date:'short' }}
            </td>
          </ng-container>

          <!-- Fecha Fin -->
          <ng-container matColumnDef="fechaFin">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Cierre</th>
            <td mat-cell *matCellDef="let row" style="font-size: 0.78rem; color: #6b7280; white-space: nowrap;">
              {{ row.fechaFin ? (row.fechaFin | date:'short') : '—' }}
            </td>
          </ng-container>

          <!-- Fecha Actualización -->
          <ng-container matColumnDef="fechaActualizacion">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>Actualización</th>
            <td mat-cell *matCellDef="let row" style="font-size: 0.78rem; color: #6b7280; white-space: nowrap;">
              {{ row.fechaActualizacion | date:'short' }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumnsHistorial"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumnsHistorial;"></tr>
        </table>
      </div>
    </div>

    <!-- Cards Mobile -->
    <div class="lg:hidden flex flex-col gap-3" *ngIf="dataSourceHistorial">
      <div *ngFor="let row of manualTransactions"
        style="background: white; border-radius: 12px; border: 1px solid #e5e7eb; overflow: hidden; box-shadow: 0 1px 4px rgba(0,0,0,0.04);">

        <!-- Card header -->
        <div (click)="toggleManualCard(row.id)"
          style="padding: 14px 16px; display: flex; align-items: center; justify-content: space-between; cursor: pointer;"
          [style.background]="expandedManualId === row.id ? 'linear-gradient(135deg, #f0fdf4, #ecfdf5)' : 'white'">
          <div style="min-width: 0; flex: 1;">
            <div class="flex items-center gap-2">
              <span style="font-weight: 700; font-size: 0.9rem; color: #1e5a3f;">
                {{ row.totalEnvio | currency:'USD':'symbol-narrow':'1.2-2':'en-US' }} {{ row.monedaLocal }}
              </span>
              <mat-icon style="font-size: 14px; width: 14px; height: 14px; color: #9ca3af; flex-shrink: 0;">arrow_forward</mat-icon>
              <span style="font-weight: 600; font-size: 0.85rem; color: #374151;">
                {{ row.totalDest | currency:'USD':'symbol-narrow':'1.2-2':'en-US' }} {{ row.monedaDestino }}
              </span>
            </div>
            <div class="flex items-center gap-2" style="margin-top: 4px;">
              <span style="font-size: 0.72rem; color: #9ca3af;">{{ row.fechaCreacion | date:'short' }}</span>
              <span style="display: inline-block; padding: 2px 8px; border-radius: 4px; font-size: 0.68rem; font-weight: 700; color: white;"
                [style.background]="getEstadoManualBg(row.estado)">
                {{ row.estado }}
              </span>
            </div>
          </div>
          <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #9ca3af; flex-shrink: 0; transition: transform 0.2s ease;"
            [style.transform]="expandedManualId === row.id ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>

        <!-- Card body -->
        <div *ngIf="expandedManualId === row.id"
          style="padding: 0 16px 14px; border-top: 1px solid #e5e7eb;">
          <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 10px; padding-top: 12px;">
            <div>
              <span style="font-size: 0.68rem; font-weight: 600; color: #9ca3af; text-transform: uppercase;">Valor Pagado</span>
              <p style="margin: 1px 0 0; font-size: 0.85rem; font-weight: 700; color: #2563eb;">
                {{ row.valorPagado | currency:'USD':'symbol-narrow':'1.2-2':'en-US' }}
              </p>
            </div>
            <div>
              <span style="font-size: 0.68rem; font-weight: 600; color: #9ca3af; text-transform: uppercase;">Tasa</span>
              <p style="margin: 1px 0 0; font-size: 0.85rem; font-weight: 600; color: #7c3aed;">{{ row.tasa }}</p>
            </div>
            <div style="grid-column: span 2;">
              <span style="font-size: 0.68rem; font-weight: 600; color: #9ca3af; text-transform: uppercase;">Wallet</span>
              <p style="margin: 1px 0 0; font-size: 0.78rem; font-weight: 600; color: #374151; font-family: monospace; word-break: break-all;">
                {{ row.walletTrx }}
              </p>
            </div>
            <div>
              <span style="font-size: 0.68rem; font-weight: 600; color: #9ca3af; text-transform: uppercase;">Fecha Cierre</span>
              <p style="margin: 1px 0 0; font-size: 0.82rem; color: #374151;">
                {{ row.fechaFin ? (row.fechaFin | date:'short') : '—' }}
              </p>
            </div>
            <div>
              <span style="font-size: 0.68rem; font-weight: 600; color: #9ca3af; text-transform: uppercase;">Actualización</span>
              <p style="margin: 1px 0 0; font-size: 0.82rem; color: #374151;">
                {{ row.fechaActualizacion | date:'short' }}
              </p>
            </div>
          </div>
        </div>

      </div>
    </div>

    <!-- Empty state -->
    <div *ngIf="!dataSourceHistorial || manualTransactions.length === 0"
      style="text-align: center; padding: 48px 20px;">
      <mat-icon style="font-size: 48px; width: 48px; height: 48px; color: #d1d5db; margin-bottom: 12px;">assignment</mat-icon>
      <p style="font-size: 0.95rem; color: #6b7280; margin: 0;">No hay transacciones de alto valor</p>
    </div>

  </div>


</div>
